// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__v2lgU","info":"PatientInfo_info__3nglx"};